import styled from 'styled-components';

export const FooterButton = styled.button`
  min-width: 4.6rem;
  height: 4.6rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;

  &:disabled {
    opacity: 0.2;
  }
`;

export const ButtonContainer = styled.div`
  position: relative;
  height: 4.6rem;
`;

export const TooltipContainer = styled.div`
  position: absolute;
  width: 20rem;
  left: 2rem;
  bottom: 4rem;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 1.6rem 1.2rem;
  border-bottom: ${({ $borderBottom }) => $borderBottom && '1px solid #f3f4f6'};
  cursor: pointer;

  &:hover {
    background-color: #eef5fd;
  }
`;
